module.exports = __webpack_public_path__ + "img/two.9cc7ade1.jpg";